import { AdminRoutes } from "@/data/enums/router";

export default [
  {
    path: "profile",
    name: "adminClientProfile",
    component: () => import("@/views/admin/clients/client/profile/index.vue"),
    meta: {
      title: "_.profile",
      breadcrumb: {
        label: "_action.edit",
        "vuex-key": "adminClient"
      }
    }
  },
  {
    path: "security",
    name: "adminClientSecurity",
    component: () => import("@/views/admin/clients/client/security/index.vue"),
    meta: {
      title: "_.security",
      breadcrumb: {
        label: "_action.edit",
        "vuex-key": "adminClient"
      }
    }
  },
  {
    path: "billing-settings",
    name: AdminRoutes.CLIENT_BILLING_SETTINGS,
    component: () =>
      import("@/views/admin/clients/client/billing/settings/index.vue"),
    meta: {
      title: "_.billing",
      breadcrumb: {
        label: "_action.edit",
        "vuex-key": "adminClient"
      }
    }
  }
];
